import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

export interface IProps {
    url: string,
    mUrl?: string,
}

export const Container = styled.div`
    width: 200px;
    position: relative;
    margin-top: 55px;

    @media (min-width: ${breakPoints.desktop}) {
        margin-right: 55px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        width: 200px;
    }

    @media (max-width: 1279px) {
        justify-content: center;
        width: 255px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: 226px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        width: 50%;
        justify-content: left;
    }
`;

export const Number = styled.div`
    width: 80px;
    height: 120px;
    background: url('${(props: IProps) => props.url}') bottom no-repeat;

    @media (min-width: ${breakPoints.desktop}) {
       margin: auto;
    }

    @media (max-width: ${breakPoints.mobile}) {
        width: 65px;
        height: 95px;
        background-size: contain;
        margin-left: 0;
    }
`;

export const Text = styled.div`
    position: absolute;
    width: 185px;
    bottom: 5px;
    left: 65px;
    ${FONTS.S};
    opacity: .8;

    @media (max-width: ${breakPoints.sDesktop}) {
        width: 175px;
        left: 6px;
    }

   @media (max-width: 1279px) {
        left: 69px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        max-width: 163px;
        ${FONTS.XS};
    }

    @media (min-width: ${breakPoints.sDesktop}) and (max-width: ${breakPoints.desktop}) {
        left: 6px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        left: 0;
        width: 135px;
        ${FONTS.XXS}
    }
`;
